
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Badge,
  Button,
  Card, CardBody,
  CardHeader, CardText, CardTitle,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle, FormGroup, Input, Label, Modal, ModalBody,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import FileService from "../../../services/fileService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ContactService from "../../../services/contactService";
import _ from "lodash";
import FormInput from "../../../components/common/form/FormInput";
import formatFrontendDate from "../util/formatFrontendDate";
import {FaFile, FaFolder} from "react-icons/fa";
import FileUploadButton from "../../../components/drive/FileUploadButton";
import Loader from "../../Loader";
import downloadUtil from "../../../util/downloadUtil";
import SecurityService from "../../../services/securityService";
import {UsersPermissions} from "../../../services/permissions";
import securityConstant from "../../../util/securityConstant";
import fileList from "../../../components/FileList";

class SharedWithMe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      fileList:[],
      filterName :null,
      filterCountry :null,
      filteredList :[],
      alert: null,
      loading: false,
      renameModal:false,
      newName:"",
      shareWith:[],
      selectedFileItem:null,
      shareModal:false,
      contactModal: false,
      contactList :[],
      filteredContacts : [],
      createdByList: [],
      createdByUniqueId: this.props.match.params.uniqueId || undefined,
      parentFolderId: this.props.match.params.folderId || undefined,
      folderStructure:[]
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
  }

  onChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  loadData = () => {
    let obj = this;
      FileService.shared().then((response) => {
        if(this.state.createdByUniqueId === undefined){
          this.setState({list: response, filteredList : response});
        } else {

          FileService.folderStructure(this.state.createdByUniqueId).then(folderResponse => {
            let foldersWithItemCount = _.map(folderResponse, folder => {
              let itemCount = _.filter(response, item => item.parentFolderId === folder.uniqueId).length;
              return { ...folder, itemCount: itemCount };
            });
            this.setState({folderStructure : foldersWithItemCount})
            if(this.state.parentFolderId !== undefined){
              let fileList = _.filter(this.state.list, file => file.parentFolderId === obj.state.parentFolderId);
              this.setState({fileList:fileList, filteredList: fileList})
            }
          })

          let filtered = _.filter(response, item => item.ownerId === this.state.createdByUniqueId);
          this.setState({list: filtered, filteredList : filtered});
        }
        // Step 1: Extract all createdByUser objects
        const createdByUsers = response.map(item => item.createdByUser);

// Step 2: Group by a unique identifier (emailAddress or uniqueId)
        const grouped = _.groupBy(createdByUsers, 'uniqueId');

// Step 3: Create array of unique users with a `count` field
        const result = _.map(grouped, (users, email) => {
          const user = users[0]; // pick the first (they're all the same per email)
          return {
            ...user,
            count: users.length
          };
        });
        this.setState({createdByList:result});
      });
  }

  componentDidMount() {
    this.loadData()

    ContactService.list().then((response) => {
      this.setState({contactList: response});
    });
  }

  hideDeleteAlert = () => {
    this.setState({
      alert: null
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
          <ReactBSAlert
              warning
              style={{display: "block"}}
              title="Are you sure?"
              onConfirm={() => this.delete(uniqueId)}
              onCancel={this.hideDeleteAlert}
              showCancel
              confirmBtnBsStyle="danger"
              confirmBtnText="Yes, delete it!"
              cancelBtnBsStyle="secondary"
              cancelBtnText="Cancel"
              btnSize=""
          >
            You won't be able to revert this!
          </ReactBSAlert>
      )
    });
  };

  applyFilter = () => {
    const { fileList, filterName } = this.state;

    const filteredList = _.filter(fileList, (file) => {
      const nameMatches = filterName ? _.includes(_.toLower(file.name), _.toLower(filterName)) : true;
      return nameMatches;
    });

    this.setState({ filteredList : filteredList });
  }

  clearFilter = () => {
    this.setState({filteredList : this.state.fileList, filterName : null, filterCountry : null })
  }

  displayContacts = (uniqueId) => {
    let filteredContacts = _.filter(this.state.contactList, value => value.company.uniqueId === uniqueId );
    this.setState({filteredContacts : filteredContacts})
    this.toggleModal("contactModal");
  }

  delete(uniqueId) {
    this.setState({alert: null})
    FileService.delete(uniqueId).then((response) => {
      this.notify(
          "success",
          "SUCCESS",
          "Deleted Successfully"
      );
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      this.loadData();
    });
  }

  toggleModal = state => {
    this.setState({
      [state]: !this.state[state]
    });
  };

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
          <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
            <span data-notify="message">{message}</span>
          </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  showRenameModal = (fileItem) => {
    this.setState({selectedFileItem: fileItem, newName:fileItem?.name})
    this.toggleModal("renameModal");
  }

  submitNewName = () => {
    const data = {
      newName: this.state.newName,
      uniqueId: this.state.selectedFileItem.uniqueId
    }
    FileService.rename(data).then(response => {
      this.toggleModal("renameModal");
      this.notify(
          "success",
          "SUCCESS",
          `Renamed successfully!`
      );
      let oldList = _.filter(this.state.list,(item) => item.uniqueId !== response.uniqueId)
      let newList = [...oldList,response]
      this.setState({list:newList, filteredList:newList})
    })
  }

  showShareModal = (fileItem) => {
    this.setState({selectedFileItem: fileItem})
    this.toggleModal("shareModal");
  }

  submitShareWith = () => {
    const data = {
      shareWith: this.state.shareWith,
      uniqueId: this.state.selectedFileItem.uniqueId
    }
    FileService.share(data).then(response => {
      this.toggleModal("shareModal");
      this.notify(
          "success",
          "SUCCESS",
          `Shared successfully with ${data.shareWith.length} emails!`
      );
      let oldList = _.filter(this.state.list,(item) => item.uniqueId !== response.uniqueId)
      let newList = [...oldList,response]
      this.setState({list:newList, filteredList:newList})
    })
  }

  addToShareWith = () =>{
    const sharedWith = [...this.state.shareWith, this.state.share]
    this.setState({shareWith:sharedWith, share:""})
  }

  isFileStructure = () => {
    return this.state.parentFolderId !== undefined && this.state.createdByUniqueId !== undefined;
}



  render() {
    let obj = this;
    return (
        <>
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert"/>
          </div>
          {this.state.loading && <Loader />}
          <SimpleHeader
              name="Shared with me"
              parentName="Drive"
              heading="XareGrwoth"
              // newBtnUrl="/admin/company/create"
              // newBtnText="Create Company"
          />
          {this.state.alert}
          <Container className="mt--6" fluid>
            <Row>
              <Col xl="12">
                <Card>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Shared With me</h3>
                      </div>
                    </Row>
                    {this.isFileStructure() &&
                        <Row>
                          <p style={{fontStyle: "italic", color: "gray"}}>
                            Use the filters below to narrow down your search results.
                          </p>
                        </Row>
                    }
                    {this.isFileStructure() &&
                        <Row>
                          <Col sm={6} md={6}>
                            <FormInput
                                name="filterName"
                                className="form-control-label"
                                id="filterName"
                                placeholder="File Name"
                                type="text"
                                onChange={this.onChange}
                                label="File Name"
                                value={this.state?.filterName || ""}
                                // errorMsg={this.props.errorObj?.name || ""}
                            />
                          </Col>
                          <Col md={"2"}></Col>
                          <Col sm={6} md={4} style={{marginTop: "30px"}}>
                            <Button size="md" outline color="default" type="button"
                                    onClick={this.applyFilter}
                            >
                              Apply Filter
                            </Button>
                            <Button color="default" size="md" outline type="button"
                                    onClick={this.clearFilter}>
                              Clear Filter
                            </Button>
                          </Col>
                        </Row>
                    }

                  </CardHeader>
                  {/*Show Folder Structure by unique users*/}
                  {this.state.createdByUniqueId === undefined &&
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                        <tr>
                          <th className="sort" data-sort="name" scope="col">
                            #
                          </th>
                          <th scope="col"/>
                          <th className="sort" data-sort="status" scope="col">
                            Name
                          </th>
                          <th className="sort" data-sort="status" scope="col">
                            Items
                          </th>


                        </tr>
                        </thead>
                        <tbody className="list">
                        {this.state.createdByList.map(function (value, index) {
                          return (
                              <tr key={index}>
                                <td className="budget">{index + 1}</td>
                                <td className="text-right">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                        color=""
                                        size="sm"
                                        className="btn-icon-only text-light"
                                    >
                                      <i className="fas fa-ellipsis-v"/>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        className="dropdown-menu-arrow"
                                        right
                                        container={document.body}
                                    >
                                      <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            obj.props.history.push(
                                                `/${SecurityService.getLayout()}/drive/shared/${value.uniqueId}`)
                                          }}
                                      >
                                        Open
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                                <td className="budget"
                                    style={{cursor: "pointer"}}
                                    onClick={() => {
                                      obj.props.history.push(
                                          `/${SecurityService.getLayout()}/drive/shared/${value.uniqueId}`)
                                    }}
                                >{value?.userCompanyName || "Company Name not set"}</td>
                                <td className="budget">{value?.count}</td>

                              </tr>
                          );
                        })}
                        </tbody>
                      </Table>
                  }
                  {/*Show folder structure for user*/}
                  {this.state.createdByUniqueId !== undefined && this.state.parentFolderId === undefined &&
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                        <tr>
                          <th className="sort" data-sort="name" scope="col">
                            #
                          </th>
                          <th scope="col"/>
                          {/*<th className="sort" data-sort="budget" scope="col">
                            Date Created
                          </th>*/}
                          <th className="sort" data-sort="status" scope="col">
                            Name
                          </th>
                          <th className="sort" data-sort="name" scope="col">
                            Items
                          </th>

                        </tr>
                        </thead>
                        <tbody className="list">
                        {this.state.folderStructure.map(function (folder, index) {
                          return (
                              <tr key={index}>
                                <td className="budget">{index + 1}</td>
                                <td className="text-right">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                        color=""
                                        size="sm"
                                        className="btn-icon-only text-light"
                                    >
                                      <i className="fas fa-ellipsis-v"/>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        className="dropdown-menu-arrow"
                                        right
                                        container="body"
                                    >
                                      {/*<DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/admin/drive/my-drive/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Open
                                    </DropdownItem>*/}
                                      {/*<DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.showRenameModal(value);
                                        }}
                                    >
                                      Rename
                                    </DropdownItem>*/}
                                      {folder.folder && <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            obj.props.history.push(
                                                `/${SecurityService.getLayout()}/drive/shared/${folder.ownerId}/folder/${folder.uniqueId}`)
                                          }}
                                      >
                                        Open
                                      </DropdownItem>}
                                      {/*{!value.folder && <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.showShareModal(value);
                                        }}
                                    >
                                      Share
                                    </DropdownItem>}
                                    <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.confirmDeleteAlert(`${value.uniqueId}`);
                                        }}
                                    >
                                      Delete
                                    </DropdownItem>*/}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                                {/*<td className="budget">{formatFrontendDate(folder.dateCreated)}</td>*/}
                                <td className="budget"
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                      if (folder.folder) {
                                        obj.props.history.push(
                                            `/${SecurityService.getLayout()}/drive/shared/${folder.ownerId}/folder/${folder.uniqueId}`
                                        );

                                      } else {
                                        downloadUtil.download({
                                          "uniqueId": folder.documentId,
                                          originalFileName: folder.name
                                        })
                                      }
                                    }}>{folder.folder && <FaFolder size={24}/>} {!folder.folder &&
                                    <FaFile size={24} color="#6c757d"/>} {folder.name}</td>
                                <td className="budget">{folder.itemCount}</td>

                              </tr>
                          );
                        })}
                        </tbody>
                      </Table>}
                  {this.state.createdByUniqueId !== undefined && this.state.parentFolderId !== undefined &&
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                        <tr>
                          <th className="sort" data-sort="name" scope="col">
                            #
                          </th>
                          <th scope="col"/>
                          <th className="sort" data-sort="budget" scope="col">
                            Date Created
                          </th>
                          <th className="sort" data-sort="status" scope="col">
                            Name
                          </th>
                          <th className="sort" data-sort="status" scope="col">
                            Owner
                          </th>


                        </tr>
                        </thead>
                        <tbody className="list">
                        {this.state.filteredList.map(function (value, index) {
                          return (
                              <tr key={index}>
                                <td className="budget">{index + 1}</td>
                                <td className="text-right">
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                        color=""
                                        size="sm"
                                        className="btn-icon-only text-light"
                                    >
                                      <i className="fas fa-ellipsis-v"/>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        className="dropdown-menu-arrow"
                                        right
                                        container="body"
                                    >
                                      {/*<DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.props.history.push(
                                              `/admin/drive/my-drive/${value.uniqueId}`
                                          );
                                        }}
                                    >
                                      Open
                                    </DropdownItem>*/}
                                      {/*<DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.showRenameModal(value);
                                        }}
                                    >
                                      Rename
                                    </DropdownItem>*/}
                                      {!value.folder && <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            downloadUtil.download({
                                              "uniqueId": value.documentId,
                                              originalFileName: value.name
                                            })
                                          }}
                                      >
                                        Download
                                      </DropdownItem>}
                                      {/*{!value.folder && <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.showShareModal(value);
                                        }}
                                    >
                                      Share
                                    </DropdownItem>}
                                    <DropdownItem
                                        onClick={(e) => {
                                          e.preventDefault();
                                          obj.confirmDeleteAlert(`${value.uniqueId}`);
                                        }}
                                    >
                                      Delete
                                    </DropdownItem>*/}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                                <td className="budget">{formatFrontendDate(value.dateCreated)}</td>
                                <td className="budget"
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                      if (value.folder) {
                                        obj.props.history.push(
                                            `/${SecurityService.getLayout()}/drive/my-drive/${value.uniqueId}`
                                        );

                                      } else {
                                        downloadUtil.download({
                                          "uniqueId": value.documentId,
                                          originalFileName: value.name
                                        })
                                      }
                                    }}>{value.folder && <FaFolder size={24}/>} {!value.folder &&
                                    <FaFile size={24} color="#6c757d"/>}
                                  {value.name}
                                </td>
                                <td className="budget">{value.createdByUser?.userCompanyName}</td>

                              </tr>
                          );
                        })}
                        </tbody>
                      </Table>}

                </Card>
              </Col>
            </Row>

            <Modal
                className="modal-dialog-centered modal-lg"
                isOpen={this.state.renameModal}
                toggle={() => this.toggleModal("renameModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  Rename
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("renameModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body">
                <ModalBody>
                  <FormGroup>
                    <Label for="renameInput">New Name</Label>
                    <Input
                        id="renameInput"
                        name="newName"
                        type="text"
                        value={this.state.newName}
                        onChange={this.onChange}
                        placeholder="Enter new name"
                    />
                  </FormGroup>
                </ModalBody>
              </div>
              <div className="modal-footer">
                <Button
                    className="ml-auto"
                    outline
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.submitNewName()}
                >
                  Rename
                </Button>
                <Button
                    className="ml-auto"
                    outline
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("renameModal")}
                >
                  Close
                </Button>
              </div>
            </Modal>
            <Modal
                className="modal-dialog-centered modal-md"
                isOpen={this.state.shareModal}
                toggle={() => this.toggleModal("shareModal")}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  Share files with
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("shareModal")}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <div className="modal-body">
                <ModalBody>
                  <Row>
                    <Col sm={10}>
                      <FormGroup>
                        <Label for="shareInput">Add email address</Label>
                        <Input
                            id="shareInput"
                            name="share"
                            type="email"
                            value={this.state.share}
                            onChange={this.onChange}
                            placeholder="eg: john@doe.com"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={2}>
                      <FormGroup>
                        <Button
                            className="ml-auto"
                            outline
                            style={{top:"34px"}}
                            color="gray"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.addToShareWith()}
                        >
                          Add
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={12}>
                      <div>
                        {this.state.shareWith.map((value, index) => {
                          return <Badge color="secondary">{value}</Badge>
                        })}
                      </div>
                    </Col>
                  </Row>
                </ModalBody>
              </div>
              <div className="modal-footer">
                <Button
                    className="ml-auto"
                    outline
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.submitShareWith()}
                >
                  Share
                </Button>
                {/*<Button
                    className="ml-auto"
                    color="gray"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleModal("shareModal")}
                >
                  Close
                </Button>*/}
              </div>
            </Modal>
          </Container>
        </>
    );
  }

  getOnFilesSelected() {
    return (files) => {
      const maxTotalSizeMB = 20;
      const totalSizeInBytes = files.reduce((acc, file) => acc + file.size, 0);
      const totalSizeInMB = totalSizeInBytes / (1024 * 1024);

      if (totalSizeInMB > maxTotalSizeMB) {
        this.notify(
            "error",
            "ERROR",
            `Total file size exceeds ${maxTotalSizeMB} MB. Please upload smaller files.`
        );
        return;
      }
      this.setState({loading:true})
      const formData = new FormData();
      files.forEach(file => {
        formData.append('files', file); // keep name as 'files', not 'files[]'
      });
      formData.append('parentFolderId', this.state.parentFolderId);

      FileService.uploadFile(formData).then(response => {
        this.setState({loading:false})
        this.loadData()
        this.notify(
            "success",
            "SUCCESS",
            `File uploaded successfully.`
        );
        this.setState({
          files: [],
        });      }).catch(error => {
        this.setState({loading:false})
      })

      // handle upload or preview logic here
    };
  }
}

export default SharedWithMe;
